import axios from "axios";
export default {
    state: {
        empresas: [],
        loadingEmpresas: false
    },
    mutations: {
        SET_EMPRESAS(state, empresas){
            state.empresas = empresas
        },
        SET_LOADING_EMPRESAS(state, loading) {
            state.loadingEmpresas = loading;
        }     
    },
    actions: {
        setEmpresas({commit, dispatch}){
            commit('SET_LOADING_EMPRESAS', true);
            axios.get('/api/empresas')
                .then((respuesta) => {
                    let empresas = respuesta.data;
                    commit('SET_EMPRESAS', empresas);
                    commit('SET_LOADING_EMPRESAS', false);
                }
            ).catch((err) => {
                commit('SET_LOADING_EMPRESAS', false);
                // console.log(err);
                dispatch('setSnackbar', {
                    snackbar: true,
                    tipo: "error",
                    mensaje: "Error. No se han podido recuperar las empresas",
                });
            });
        }
    }
}